import { PageViewEvent } from '@shopify/standard-events';

function dispatchPageViewEvent() {
  const templateElement = document.querySelector('main[data-template]');
  const template = templateElement instanceof HTMLElement ? templateElement.dataset.template || '' : '';

  document.dispatchEvent(
    new PageViewEvent({
      page: {
        template,
        title: document.title,
        url: window.location.href,
      },
    })
  );
}

if (document.readyState === 'complete') {
  queueMicrotask(dispatchPageViewEvent);
} else {
  document.addEventListener('DOMContentLoaded', dispatchPageViewEvent, { once: true });
}
